import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const CBTag = ({
  children,
  color, // Tailwind color class (e.g., 'bg-blue-100 text-blue-800') or predefined names ('blue', 'green', etc.)
  closable = false,
  onClose, // (event) => void
  icon, // ReactNode
  className = '',
}) => {
  let colorClasses = '';
  // Map predefined colors or use Tailwind directly
  if (color && !color.includes('-')) {
    switch (color) {
      case 'blue': colorClasses = 'bg-[#DBEAFE] text-[#1E40AF] border-[#1E40AF]'; break;
      case 'green': colorClasses = 'bg-[#D1FAE5] text-[#065F46] border-[#065F46]'; break;
      case 'red': colorClasses = 'bg-red-100 text-red-800 border-red-800'; break;
      case 'yellow': colorClasses = 'bg-yellow-100 text-yellow-800 border-yellow-800'; break;
      case 'gray': // Default/neutral
      default: colorClasses = 'bg-gray-100 text-gray-800 border-gray-800'; break;
    }
  } else if (color) {
    colorClasses = color; // Assume it's already Tailwind classes
  } else {
    colorClasses = 'bg-gray-100 text-gray-800'; // Default
  }

  const handleClose = (e) => {
    e.stopPropagation(); // Prevent click event on parent
    if (onClose) {
      onClose(e);
    }
  };

  return (
    <div
      className={`inline-flex border items-center px-2.5 py-0.5 rounded-md  font-medium ${colorClasses} ${className}`}
    >
      {icon && <span className="mr-1.5">{icon}</span>}
      {children}
      {closable && (
        <button
          type="button"
          className="flex-shrink-0 ml-1.5 -mr-0.5 rounded-full inline-flex items-center justify-center text-current hover:bg-opacity-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" // Adjust focus ring color as needed
          onClick={handleClose}
        >
          <span className="sr-only">Remove tag</span>
          <FontAwesomeIcon icon={faTimes} className="h-3 w-3" />
        </button>
      )}
    </div>
  );
};

export { CBTag };